import DestinationReliabilities from 'app/collections/destination_reliabilities';
import DateRange, { DATERANGE_PARAM_TYPES } from 'app/models/date_range';
import DropdownSelection from 'app/models/dropdown_selection';

import Base from 'app/views/base';
import DatepickerRangeView from 'app/views/datepicker_range_view';
import SelectorView from 'app/views/selector_view';

import { List as ListView, Heading } from 'app/components/list/list';
import PageHeaderView from 'app/components/page_header';

import tmpl from './template';

export const buildHeadings = () => {
  return [
    new Heading({
      property: 'carrier',
      display: 'Carrier',
      xsSize: 3,
      smSize: 3,
    }),
    new Heading({
      property: 'destination',
      display: 'Destination',
      xsSize: 5,
      smSize: 5,
    }),
    new Heading({
      display: 'Chance of Exception',
      text: m => `${m.get('percent')}%`,
      wrapperClass: 'text-right',
      xsSize: 4,
      smSize: 4,
    }),
  ];
};

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'fulfillment_orders',

  initialize() {
    this.dateRange = new DateRange({ paramType: DATERANGE_PARAM_TYPES.DATE });

    this.carrierSelection = new DropdownSelection({
      choices: [
        { option: 'usps', readable: 'USPS' },
        { option: 'fedex', readable: 'FedEx' },
        { option: 'ups', readable: 'UPS' },
      ],
      label: 'Carrier',
      paramKey: 'carrier',
    });

    this.servicePrioritySelection = new DropdownSelection({
      choices: [
        { option: '', readable: 'All Service Levels' },
        { option: 'standard', readable: 'Standard' },
        { option: 'express', readable: 'Express' },
      ],
      label: 'Service Priority',
      paramKey: 'service_priority',
    });

    this.destinationLevelSelection = new DropdownSelection({
      choices: [
        { option: 'city', readable: 'City' },
        { option: 'zip3', readable: 'Zip3' },
        { option: 'zip5', readable: 'Zip5' },
      ],
      label: 'Level',
      paramKey: 'destination_level',
    });

    this.exceptionTypeSelection = new DropdownSelection({
      choices: [
        { option: '', readable: 'Any Exceptions' },
        { option: 'transit', readable: 'Transit Exceptions' },
        { option: 'delivery', readable: 'Delivery Exceptions' },
      ],
      label: 'Exception Type',
      paramKey: 'exceptions_type',
    });

    this.collection = new DestinationReliabilities([], {
      dateRange: this.dateRange,
      carrierSelection: this.carrierSelection,
      servicePrioritySelection: this.servicePrioritySelection,
      destinationLevelSelection: this.destinationLevelSelection,
      exceptionTypeSelection: this.exceptionTypeSelection,
    });

    this.addSubview('header', 'header', new PageHeaderView({
      name: 'Destination Reliability',
    }));
    this.addSubview('carrierPicker', '#carrier_picker', new SelectorView({
      model: this.carrierSelection,
    }));
    this.addSubview('servicePriorityPicker', '#service_priority_picker', new SelectorView({
      model: this.servicePrioritySelection,
    }));
    this.addSubview('destinationLevelPicker', '#destination_level_picker', new SelectorView({
      model: this.destinationLevelSelection,
    }));
    this.addSubview('exceptionTypePicker', '#exception_type_picker', new SelectorView({
      model: this.exceptionTypeSelection,
    }));
    this.addSubview('datepickers', '#daterange_pickers', new DatepickerRangeView({
      model: this.dateRange
    }));
    this.addSubview('destinationReliabilityList', '#destination_reliability_list', new ListView({
      headings: buildHeadings(),
      collection: this.collection,
      noResultsMessage: 'No results.',
      columnClasses: 'col-lg-6 col-md-9',
    }));
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/destination_reliability/index.js